import {  Component,OnDestroy, OnInit } from '@angular/core';
import { ProcesoReporte } from '../../../base/proceso-reporte';
import { AppComponent } from 'src/app/app.component';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { DatePipe } from '@angular/common';
import { MessageService } from 'primeng/api';
import { FormBuilder } from '@angular/forms';
import { IHeader, Pdf } from 'src/app/clases/pdf';
import { XlsxService } from 'src/app/services/utils/xlsx.service';
import { GestionCobrosService } from 'src/app/services/seguimiento/gestion-cobros.service';


@Component({
  selector: 'app-gestion-cobros',
  templateUrl: './gestion-cobros.component.html',
  styleUrls: ['./gestion-cobros.component.scss']
})
export class GestionCobrosComponent extends ProcesoReporte implements OnInit {

  grafico !: Highcharts.Chart | undefined | any;
  mostrarGrafico : boolean = false;
  totalDuracionLlamadas = 0;
  totalTiempoLlamada = 0;
  totalPromedio = 0;
  totalLlamadas = 0; 
  pantallaCompletaGrafico : boolean = false;
  //'MMIRANDA','ANOGUERA','LMONTIEL','NARCE','ALUGO'
  usuarios = [
    { nombre: 'MMIRANDA', valor: 'MMIRANDA' },
    { nombre: 'ANOGUERA', valor: 'ANOGUERA' },
    { nombre: 'LMONTIEL', valor: 'LMONTIEL' },
    { nombre: 'NARCE', valor: 'NARCE' },
    { nombre: 'ALUGO', valor: 'ALUGO' },
  ]

  recuperadores: Record< string, any >[] = [];
  resumenRecuperadores: Record< string, any >[] = [];
  datosAnteriores: Record< string, any >[] = [];
  estadosLlamada : Record< string, any >[]= [
    { nombre: 'Respondido', valor:'ANSWERED'},
    { nombre: 'Sin Respuesta', valor:'NO ANSWER'},
    { nombre: 'Ocupado', valor:'BUSY'},
    { nombre: 'Congestion', valor:'CONGESTION'},
  ]
  todosLosEstados = [ 'ANSWERED', 'NO ANSWER', 'BUSY', 'CONGESTION' ]
  totalLlamadasRepetidas = 0;
  constructor(
    public app: AppComponent, 
    private breadcrumbService: AppBreadcrumbService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    private xlsxService : XlsxService,
    private gestionCobrosService: GestionCobrosService,
  ) {
    super();
    this.crearFormulario();
    this.breadcrumbService.setItems([ { label: 'Gestion de Cobros' } ]);
  }
  ngOnInit(): void {
    setTimeout(() => {
      this.setAllUsuarios();
    },200)
  }

  async crearFormulario() {
    const hoy = new Date();
    const fechaDesde = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), 0, 0, 0); // 00:00:00
    const fechaHasta = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate(), 23, 59, 59); // 23:59:59
    
    this.formGroup = this.fb.group({
      fecha_desde: [fechaDesde],
      fecha_hasta: [fechaHasta],
      usuarios: [[]],
    });
  }

  async ejecutar(){
    this.items = [];
    const value = this.formGroup.getRawValue();
    try {    
        this.loading = true;
        this.items = []
        value['fecha_desde'] = this.datePipe.transform(value.fecha_desde, 'yyyy-MM-dd');
        value['fecha_hasta'] = this.datePipe.transform(value.fecha_hasta, 'yyyy-MM-dd');
        if( value['recuperadores'] === null ){ value['recuperadores'] = [] }
        let resPF : Record< string, any > = {};
        let resTech : Record< string, any > = {};
        //CONSULTA A PF
        try{
          resPF = await this.gestionCobrosService.getCobrosPagoFacil( value );
        } catch( error ) {
          this.messageService.add( {severity: 'info', summary: 'Ocurrio un error al consultar', detail: 'Algunos datos no se pudieron recuperar'});
          console.error(`Ocurrio un error en el base de datos de PF:`, error )
        }
        //CONSULTA A TECH
        try{
          resTech = await this.gestionCobrosService.getCobrosTech( value );
        } catch( error ) {
          this.messageService.add( {severity: 'info', summary: 'Ocurrio un error al consultar', detail: 'Algunos datos no se pudieron recuperar'});
          console.error(`Ocurrio un error en el base de datos de PF:`, error )
        }
        //SI EXISTEN DATOS DE PF LO AGREGAMOS
        if( resPF?.resp?.length > 0 && resPF.resp ) { 
          this.items = [...this.items, ...resPF.resp];
        } 
        //SI EXISTEN DATOS DE TECH LO AGREGAMOS
        if( resTech?.resp?.length > 0 && resTech.resp ) { 
          this.items = [ ...this.items, ...resTech.resp ];
        } 
        if( this.items.length < 1 ){
          this.messageService.add( {severity: 'info', summary: 'Sin resultados', detail: 'No se encontraron cobros'});
        }
        this.loading = false;
    } catch (error: any) {
        this.messageService.add({severity: 'error', 'summary': 'Ocurrio un error al traer los cobros'})
        console.error( error )
        this.loading = false;
    }
  }
  
  traducirCondicion( condicion: boolean ) : string {
    return condicion ? 'Si' : 'No';
  }

  async setAllUsuarios(){
    for ( const usuario of this.usuarios ){
      const usuarios =  [ ...this.formGroup.get('usuarios').value ]
      usuarios.push( usuario.nombre )
      this.formGroup.get('usuarios').setValue( usuarios );
    }
  }

  async descargar() {
      const pdf = new Pdf(this.currentUser);
      const value = this.formGroup.getRawValue();
      pdf.title =  `Informe de Cobros - Periodo: ${ this.datePipe.transform(value.fecha_desde, 'dd/MM/yyyy')} - ${ this.datePipe.transform(value.fecha_hasta, 'dd/MM/yyyy')}`;
              pdf.headers = [
            { label: 'Nro. Actividad', name: 'nro_actividad', type: 'text' },
            { label: 'Nombre Entidad', name: 'nombre_entidad', type: 'text' },
            { label: 'Agrupacion', name: 'agrupacion', type: 'text' },
            { label: 'Nro Documento', name: 'nro_documento', type: 'number' },
            { label: 'Nombre Cliente', name: 'nombre_cliente', type: 'text' },
            { label: 'Nro Operacion', name: 'nro_operacion', type: 'number' },
            { label: 'Fecha Gestion', name: 'fecha_gestion', type: 'date' },
            { label: 'Nombre Usuario', name: 'nom_usuario', type: 'text' },
            { label: 'Fecha Promesa de Pago', name: 'fecha_promesa_pago', type: 'date' },
            // { label: 'Observaciones', name: 'observaciones', type: 'text' },
            { label: 'Agendar Pago', name: 'agendar_pago', type: 'text' },
            { label: 'Generar Act Nota', name: 'generar_act_nota', type: 'text' },
            { label: 'Confirmacion Compromiso', name: 'confirmacion_compromiso', type: 'text' },
            { label: 'Reagendar Llamada', name: 'reagendar_llamada', type: 'text' },
            { label: 'Confirmacion Cobro', name: 'confirmacion_cobro', type: 'text' },
        ]
        for (const item of this.items) {
            item['agendar_pago'] = await this.traducirCondicion( value.agendar_pago );
            item['generar_act_nota'] = await this.traducirCondicion( value.generar_act_nota );
            item['confirmacion_compromiso'] = await this.traducirCondicion( value.confirmacion_compromiso );
            item['reagendar_llamada'] = await this.traducirCondicion( value.reagendar_llamada );
            item['confirmacion_cobro'] = await this.traducirCondicion( value.confirmacion_cobro );
            pdf.addSource({ 
                data: item,
            });
        }
        pdf.exportar();
  }
  async descargarExcel() {
      const datos: Record<string, any>[] = [];
      const value = this.formGroup.getRawValue();
      for (const item of this.items) {
        datos.push({
          'Nro. Actividad': item.nro_actividad,
          'Nombre Entidad': item.nombre_entidad,
          'Agrupacion': item.agrupacion,
          'Nro Documento': item.nro_documento,
          'Nombre Cliente': item.nombre_cliente,
          'Nro Operacion': item.nro_operacion,
          'Fecha Gestion': this.datePipe.transform( item.fecha_gestion, 'dd/MM/yyyy' ),
          'Nombre Usuario': item.nom_usuario,
          'Fecha Promesa de Pago': this.datePipe.transform( item.fecha_promesa_pago, 'dd/MM/yyyy' ),
          'Observaciones': item.observaciones,
          'Agendar Pago': await this.traducirCondicion( item.agendar_pago ),
          'Generar Act Nota': await this.traducirCondicion( item.generar_act_nota ),
          'Confirmacion Compromiso': await this.traducirCondicion( item.confirmacion_compromiso ),
          'Reagendar Llamada': await this.traducirCondicion( item.reagendar_llamada ),
          'Confirmacion Cobro': await this.traducirCondicion( item.confirmacion_cobro ),
        })
      }
      await this.xlsxService.exportAsExcelFile(datos, `informe_cobros_${ this.datePipe.transform(value.fecha_desde, 'dd/MM/yyyy')}-${ this.datePipe.transform(value.fecha_hasta, 'dd/MM/yyyy')}`);
  }

}
